module.exports = __webpack_public_path__ + "static/img/1.b911e23d.jpeg";